import { BarChart3, Home, Settings, User } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

const TABS = [
  { path: "/child/home", label: "Hjem", Icon: Home },
  { path: "/child/week", label: "Uka", Icon: BarChart3 },
  { path: "/child/history", label: "Meg", Icon: User },
  { path: "/settings", label: "Mer", Icon: Settings },
];

export function MobileTabBar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        background: "rgba(255,255,255,0.92)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        borderTop: "1px solid var(--line)",
        paddingBottom: "env(safe-area-inset-bottom, 16px)",
        paddingTop: 8,
        display: "flex",
        justifyContent: "space-around",
        zIndex: 50,
      }}
    >
      {TABS.map(({ path, label, Icon }) => {
        const active = pathname === path;
        return (
          <button
            type="button"
            key={path}
            onClick={() => navigate(path)}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              padding: "6px 10px",
              borderRadius: 12,
              color: active ? "var(--forest)" : "var(--ink-3)",
            }}
          >
            <Icon size={22} color="currentColor" />
            <span style={{ fontSize: 10, fontWeight: 600, letterSpacing: 0.2 }}>
              {label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
